/* JC-EVO 09/26/2026: product hero design C "Gallery first + floating summary" (jc-pdp-buy.js). Plan
   memory/plans/fast-pdp-buy-c.md. Loaded (defer) by blocks/custom-product-media.liquid only inside the product hero
   section_tYrPHc. Styles in assets/jc-pdp-buy.css. No Horizon file is edited; nothing here changes a Horizon element's
   behaviour except the documented data-puppet flag (the same one Horizon's own sticky-add-to-cart.js uses).
   1. Phone swipe gallery (markup server-rendered by the gallery block): dots follow the scroll; tapping slide k selects
      the block's k-th thumbnail and opens the block's own lightbox there; focus goes to the lightbox close button and
      comes back to the slide of the image last shown when it closes.
   2. --jc-pdp-media-h / --jc-pdp-thumbs-h (photo column / thumbnail rows) for the fit-to-screen photo tile and the
      sticky rule (a column still taller than the screen sticks by its bottom edge).
   3. Hyphenated words in the product name (U1-W, 4-in-1) never break at the hyphen (same as closing band B).
   4. Floating summary bar (<body> child): name + price + a button that is a PROXY of the real Add to cart: it clicks the
      real button, so the real form posts its own variant id, quantity, selling plan and properties. It mirrors the real
      button's label (incl. the pre-order label and "Sold out") and disabled state and the hero price, and is hidden
      (hidden attribute = display none: not in the accessibility tree or the tab order) whenever the real buy row or
      the closing band's Add to cart is on screen, while the footer is on screen or the photo lightbox is open, and
      (>=750px) once the product tabs bar has stuck. Never built for call-for-price products.
   Horizon core names/behaviour used: .buy-buttons-block, button[name="add"] (label = its bare text node beside icon
     spans), .group-block-content, [ref="priceContainer"] (replaced on variant change: re-queried every time),
     .product-form-text__error + .hidden, data-puppet (AddToCartComponent.handleClick reads it synchronously during the
     click dispatch), #header-component, .product-tabs-wrapper, .page-wrapper > .page-footer (RC13 p1: the footer group wrapper is a div since 10/09). If one is renamed by a Horizon
     update the bar is simply not built / not shown; the real form is never touched.
   Custom names used: .cpm, .cpm__thumb, .cpm__main, [data-lightbox] (.is-open, [data-lightbox-image],
     .cpm-lightbox__close, .cpm-lightbox), .jc-pdp-swipe/.jc-pdp-slide/.jc-pdp-dots, .custom-price-block, .jc-call-for-price,
     .cap__add-to-cart (closing band). Idempotent; re-runs on shopify:section:load (the old bar is torn down with its listeners). Writes nothing to
   <body> or <html> (a third-party script restores <body class> when it changes: never fight it). */
(function () {
  'use strict';
  if (window.jcPdpBuy) return;
  window.jcPdpBuy = true;

  var SEL = '[id^="shopify-section-"][id$="__section_tYrPHc"]';
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  function q(root, s) { return root ? root.querySelector(s) : null; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function onMedia(mq, fn, off) { if (mq.addEventListener) mq[off ? 'removeEventListener' : 'addEventListener']('change', fn); else if (mq.addListener) mq[off ? 'removeListener' : 'addListener'](fn); }
  var LABELTEAR = {};                            // hero id -> label-line listeners/observers cleanup
  var TEAR = {};                                   // section id -> teardown of its bar (theme editor re-render / unload)
  // JC-EVO core fork 09/30/2026: html[data-jc-pdp-bar] == "a direct <body> child .jc-pdp-bar is not [hidden]" (the old CSS :has() predicate;
  // an attribute, not a class: a third-party script restores classes),
  // recomputed wherever this file creates, shows, hides or removes a bar. jc-pdp-buy.css keys the widget offsets off it.
  function barClass() { document.documentElement.toggleAttribute('data-jc-pdp-bar', !!document.querySelector('body > .jc-pdp-bar:not([hidden])')); }

  // JC-EVO 10/07/2026 (RC10 r5b): expose only cards overlapping their own scroller.
  function jcClippedCards(root, selector, motion) {
    try {
      if (!root || !window.IntersectionObserver) return null;
      var seen = [], frame = 0, until = 0, resizeTimer = 0, focusTimer = 0, sizeObserver;
      function sync() {
        try {
          if (!root.isConnected) { stop(); return; }
          var box = root.getBoundingClientRect(), left = box.left + root.clientLeft, top = box.top + root.clientTop;
          var right = left + root.clientWidth, bottom = top + root.clientHeight;
          var cards = root.querySelectorAll(selector);
          for (var i = 0; i < seen.length; i++) {
            if (!root.contains(seen[i])) { observer.unobserve(seen[i]); seen.splice(i--, 1); }
          }
          for (var j = 0; j < cards.length; j++) {
            var card = cards[j], rect = card.getBoundingClientRect();
            if (seen.indexOf(card) === -1) { seen.push(card); observer.observe(card); }
            var visible = Math.min(rect.right, right) > Math.max(rect.left, left) && Math.min(rect.bottom, bottom) > Math.max(rect.top, top);
            if (visible || card.contains(document.activeElement)) {
              if (card.hasAttribute('aria-hidden')) card.removeAttribute('aria-hidden');
              if (card.hasAttribute('inert')) card.removeAttribute('inert');
            } else {
              if (card.getAttribute('aria-hidden') !== 'true') card.setAttribute('aria-hidden', 'true');
              if (!card.hasAttribute('inert')) card.setAttribute('inert', '');
            }
          }
        } catch (e) {}
      }
      var observer = new IntersectionObserver(sync, { root: root, threshold: 0 });
      function tick() {
        frame = 0; sync();
        if (root.isConnected && Date.now() < until) frame = window.requestAnimationFrame(tick);
      }
      function moving() { sync(); until = Date.now() + 850; if (!frame) frame = window.requestAnimationFrame(tick); }
      function resized() { window.clearTimeout(resizeTimer); resizeTimer = window.setTimeout(sync, 100); }
      function focusLeft() { window.clearTimeout(focusTimer); focusTimer = window.setTimeout(sync, 0); }
      var changes = new MutationObserver(moving);
      changes.observe(root, { childList: true, subtree: true });
      root.addEventListener('scroll', sync, { passive: true });
      root.addEventListener('scrollend', sync);
      root.addEventListener('focusout', focusLeft);
      window.addEventListener('resize', resized, { passive: true });
      if (window.ResizeObserver) { sizeObserver = new ResizeObserver(resized); sizeObserver.observe(root); }
      if (motion) { motion.addEventListener('transitionrun', moving); motion.addEventListener('animationstart', moving); }
      function unloaded(e) { if (e.target && e.target.contains(root)) stop(); }
      document.addEventListener('shopify:section:unload', unloaded);
      function stop() {
        observer.disconnect(); changes.disconnect(); window.cancelAnimationFrame(frame);
        window.clearTimeout(resizeTimer); window.clearTimeout(focusTimer);
        root.removeEventListener('scroll', sync); root.removeEventListener('scrollend', sync); root.removeEventListener('focusout', focusLeft);
        window.removeEventListener('resize', resized);
        document.removeEventListener('shopify:section:unload', unloaded);
        if (sizeObserver) sizeObserver.disconnect();
        if (motion) { motion.removeEventListener('transitionrun', moving); motion.removeEventListener('animationstart', moving); }
      }
      sync();
      return { sync: sync, moving: moving, stop: stop };
    } catch (e) { return null; }
  }

  /* ---------- 1. phone swipe gallery ---------- */
  function gallery(sec) {
    var strip = q(sec, '.jc-pdp-swipe');
    if (!strip || strip.dataset.jcInit) return;
    strip.dataset.jcInit = '1';
    var cpm = strip.closest('.cpm');
    var slides = Array.prototype.slice.call(strip.querySelectorAll('.jc-pdp-slide'));
    var dots = Array.prototype.slice.call(sec.querySelectorAll('.jc-pdp-dots > span'));
    var thumbs = cpm.querySelectorAll('.cpm__thumb');
    var main = q(cpm, '.cpm__main');
    var lb = document.querySelector('[data-lightbox="' + cpm.getAttribute('data-product-media') + '"]');
    var visibility = jcClippedCards(strip, '.jc-pdp-slide', null);
    if (visibility) strip.jcA11ySync = visibility.moving;
    var on = 0, queued = false, opener = null;
    function index() { return Math.max(0, Math.min(slides.length - 1, Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)))); }
    function paint() {
      queued = false;
      var i = index();
      if (i === on) return;
      on = i;
      each(dots, function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    strip.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(paint); } }, { passive: true });
    if (PHONE.matches && slides[1]) { var img2 = slides[1].querySelector('img'); if (img2) img2.loading = 'eager'; }
    slides.forEach(function (slide, k) {
      slide.addEventListener('click', function () {
        if (!thumbs[k] || !main) return;
        thumbs[k].click();                         // the block's handler: active thumbnail k (its mobile scrollIntoView is a no-op on the hidden strip)
        main.click();                              // the block's handler: opens its lightbox at the active thumbnail
        if (lb && lb.classList.contains('is-open')) {
          opener = slide;
          var tries = 0;
          (function focusClose() {                 // the lightbox fades in from visibility:hidden: retry until it takes focus
            var close = q(lb, '.cpm-lightbox__close');
            if (!close || !lb.classList.contains('is-open')) return;
            close.focus({ preventScroll: true });
            if (document.activeElement !== close && ++tries < 10) setTimeout(focusClose, 50);
          })();
        }
      });
    });
    if (lb && window.MutationObserver) {
      new MutationObserver(function () {
        if (lb.classList.contains('is-open') || !opener) return;
        var img = q(lb, '[data-lightbox-image]');
        var src = img && img.getAttribute('src');
        var k = slides.indexOf(opener);
        slides.forEach(function (s, j) { var i = s.querySelector('img'); if (src && i && i.getAttribute('src') === src) k = j; });
        strip.scrollTo({ left: k * strip.clientWidth, behavior: 'auto' });
        if (visibility) visibility.moving();
        var a = document.activeElement;
        if (!a || a === document.body || lb.contains(a)) slides[k].focus({ preventScroll: true });
        opener = null;
      }).observe(lb, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ---------- 2. photo column + thumbnail row heights for the sticky / fit-to-screen rules ---------- */
  function media(sec) {
    var cpm = q(sec, '.cpm');
    if (!cpm || cpm.dataset.jcH || !window.ResizeObserver) return;
    cpm.dataset.jcH = '1';
    var thumbs = q(cpm, '.cpm__thumbs');
    function measure() {
      var h = Math.ceil(cpm.getBoundingClientRect().height) + 'px';
      var t = (thumbs ? Math.ceil(thumbs.getBoundingClientRect().height) : 0) + 'px';
      if (sec.style.getPropertyValue('--jc-pdp-media-h') !== h) sec.style.setProperty('--jc-pdp-media-h', h);
      if (sec.style.getPropertyValue('--jc-pdp-thumbs-h') !== t) sec.style.setProperty('--jc-pdp-thumbs-h', t);
    }
    var ro = new ResizeObserver(measure);
    ro.observe(cpm);
    if (thumbs) ro.observe(thumbs);
  }

  /* ---------- 3. no line break at the hyphen of U1-W, 4-in-1, 3-Year ---------- */
  function nowrapHyphens(sec) {
    var h1 = q(sec, '.text-block h1');
    if (!h1 || h1.dataset.jcNw || h1.children.length) return;
    h1.dataset.jcNw = '1';
    var parts = h1.textContent.split(/(\s+)/);
    if (!parts.some(function (p) { return /\S-\S/.test(p); })) return;
    h1.textContent = '';
    parts.forEach(function (p) {
      if (/\S-\S/.test(p)) { var w = document.createElement('span'); w.style.whiteSpace = 'nowrap'; w.textContent = p; h1.appendChild(w); }
      else if (p) h1.appendChild(document.createTextNode(p));
    });
  }

  /* ---------- matching natural one/two-line hero card labels ---------- */
  function labelLines(sec) {
    if (LABELTEAR[sec.id] && LABELTEAR[sec.id].section === sec) return;
    if (LABELTEAR[sec.id]) LABELTEAR[sec.id]();
    if (!q(sec, '.cta-wyg.key_benefits-hero')) return;
    var records = [], known = new WeakMap(), widths = new WeakMap(), queued = false, dead = false, lastInput = null;
    function restore(r) {
      if (r.forced && r.p.style.getPropertyValue('max-width') === r.forced) {
        if (r.max) r.p.style.setProperty('max-width', r.max, r.priority);
        else r.p.style.removeProperty('max-width');
      }
      if (r.forced && r.p.style.getPropertyValue('max-width') !== r.forced && r.p.style.getPropertyValue('max-width') !== r.max) {
        r.max = r.p.style.getPropertyValue('max-width'); r.priority = r.p.style.getPropertyPriority('max-width');
      }
      r.forced = null;
    }
    function count(p) {
      var range = document.createRange(), tops = [];
      range.selectNodeContents(p);
      each(range.getClientRects(), function (r) {
        if (r.width > 0 && r.height > 0 && !tops.some(function (y) { return Math.abs(y - r.top) < 2; })) tops.push(r.top);
      });
      return tops.length;
    }
    function twoLineWidth(p) {                    // measure real rich-text ranges at natural one-line width, not guessed font metrics
      var walk = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), nodes = [], node, offset = 0;
      while ((node = walk.nextNode())) { nodes.push({ node: node, start: offset, end: offset + node.length }); offset += node.length; }
      function measure(a, b) {
        var range = document.createRange(), first = null, last = null;
        nodes.forEach(function (n) { if (!first && a >= n.start && a < n.end) first = n; if (!last && b > n.start && b <= n.end) last = n; });
        if (!first || !last) return 0;
        range.setStart(first.node, a - first.start); range.setEnd(last.node, b - last.start);
        return range.getBoundingClientRect().width;
      }
      var text = p.textContent, breaks = /[ \t\r\n]+|-/g, match, best = Infinity;
      while ((match = breaks.exec(text))) {
        var left = match.index + (match[0] === '-' ? 1 : 0), right = match.index + match[0].length;
        if (!text.slice(0, left).trim() || !text.slice(right).trim()) continue;
        best = Math.min(best, Math.max(measure(0, left), measure(right, text.length)));
      }
      return isFinite(best) ? Math.ceil(best) + 1 : null;
    }
    function signature() {
      var fonts = document.fonts ? Array.from(document.fonts).map(function (f) { return [f.family, f.style, f.weight, f.status]; }) : [];
      var inputs = [];
      each(sec.querySelectorAll('.cta-wyg.key_benefits-hero .wyg__grid'), function (grid) {
        var g = grid.getBoundingClientRect(), gs = getComputedStyle(grid), items = [];
        each(grid.children, function (item) {
          var ir = item.getBoundingClientRect(), style = getComputedStyle(item), text = [];
          each(item.querySelectorAll('.wyg__content p, .wyg__item-title'), function (p) {
            var ps = getComputedStyle(p), r = known.get(p), current = p.style.getPropertyValue('max-width');
            text.push([p.innerHTML, r && current === r.forced ? r.max : current,
              ps.fontFamily, ps.fontSize, ps.fontWeight, ps.fontStyle, ps.fontStretch, ps.fontVariationSettings, ps.fontFeatureSettings,
              ps.lineHeight, ps.letterSpacing, ps.wordSpacing, ps.whiteSpace, ps.textTransform, ps.wordBreak, ps.overflowWrap]);
          });
          items.push([ir.width, Math.round((ir.top - g.top) * 10), style.paddingLeft, style.paddingRight, text]);
        });
        inputs.push([g.width, gs.gridTemplateColumns, items]);
      });
      return JSON.stringify([fonts, inputs]);
    }
    function update() {
      queued = false;
      if (dead || !sec.isConnected) return;
      if (signature() === lastInput) return;       // duplicate resize/font/DOM notifications write zero styles, including to tabs observers
      records = records.filter(function (r) { return r.p.isConnected; });
      records.forEach(restore);                    // always measure natural wrapping first, so wider viewports recover one line
      each(sec.querySelectorAll('.cta-wyg.key_benefits-hero .wyg__grid'), function (grid) {
        if (ro && !widths.has(grid)) { widths.set(grid, grid.getBoundingClientRect().width); ro.observe(grid); }
        var rows = [];
        each(grid.children, function (item) {
          if (!item.classList.contains('wyg__item') || !box(item)) return;
          var content = q(item, '.wyg__content'), texts = content && content.querySelectorAll('p, .wyg__item-title');
          if (!texts || texts.length !== 1 || !box(texts[0])) return;  // short badge labels only; never descriptive cards
          var p = texts[0], r = known.get(p);
          if (!r) { r = { p: p, max: p.style.getPropertyValue('max-width'), priority: p.style.getPropertyPriority('max-width'), forced: null }; known.set(p, r); records.push(r); }
          var top = item.getBoundingClientRect().top, row = rows.filter(function (x) { return Math.abs(x.top - top) < 2; })[0];
          if (!row) { row = { top: top, labels: [] }; rows.push(row); }
          row.labels.push({ record: r, lines: count(p) });
        });
        rows.forEach(function (row) {
          if (row.labels.length < 2 || Math.max.apply(null, row.labels.map(function (l) { return l.lines; })) !== 2) return;
          row.labels.forEach(function (l) {
            if (l.lines !== 1) return;
            var r = l.record, width = twoLineWidth(r.p);
            if (!width || width >= r.p.getBoundingClientRect().width) return;
            r.p.style.setProperty('max-width', width + 'px', r.priority);
            r.forced = r.p.style.getPropertyValue('max-width');
            if (count(r.p) !== 2) restore(r);       // never force overflow, extra lines or an unbreakable single word
          });
        });
      });
      lastInput = signature();                    // include settled row geometry, excluding our own forced max-width values
    }
    function schedule() { if (!dead && !queued) { queued = true; requestAnimationFrame(update); } }
    var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
      entries.forEach(function (e) { if (Math.abs((widths.get(e.target) || 0) - e.contentRect.width) > 0.5) { widths.set(e.target, e.contentRect.width); schedule(); } });
    }) : null;                                    // only width changes; our own label-height changes cannot trigger a resize loop
    var mo = new MutationObserver(schedule);
    mo.observe(sec, { subtree: true, childList: true, characterData: true }); // own max-width attributes are deliberately not observed
    window.addEventListener('resize', schedule);
    if (document.fonts) { document.fonts.ready.then(schedule); document.fonts.addEventListener('loadingdone', schedule); }
    var tear = function () {
      dead = true; mo.disconnect(); if (ro) ro.disconnect();
      window.removeEventListener('resize', schedule);
      if (document.fonts) document.fonts.removeEventListener('loadingdone', schedule);
      records.forEach(restore); delete LABELTEAR[sec.id];
    };
    tear.section = sec; LABELTEAR[sec.id] = tear;
    schedule();
  }

  /* ---------- 4. floating summary bar = proxy of the real Add to cart ---------- */
  function labelOf(b) {
    for (var i = 0; i < b.childNodes.length; i++) {
      var n = b.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n.textContent.replace(/\s+/g, ' ').trim();
    }
    return b.textContent.replace(/\s+/g, ' ').trim();
  }
  function box(e) { var r = e && e.getBoundingClientRect(); return r && r.height > 0 ? r : null; }

  function bar(sec) {
    if (sec.dataset.jcBar) return;
    if (TEAR[sec.id]) TEAR[sec.id]();              // editor re-render: the old bar goes with all its listeners and observers
    each(document.querySelectorAll('.jc-pdp-bar[data-jc-for="' + sec.id + '"]'), function (e) { e.remove(); });
    barClass();
    function realBtn() { return q(sec, '.buy-buttons-block button[name="add"]'); }
    var first = realBtn();
    if (q(sec, '.jc-call-for-price') || !first) return;
    var col = first.closest('.group-block-content') || sec;
    sec.dataset.jcBar = '1';

    var h1 = q(sec, '.text-block h1');
    var el = document.createElement('div');
    el.className = 'jc-pdp-bar';
    el.setAttribute('data-jc-for', sec.id);
    el.hidden = true;
    var name = document.createElement('p');
    name.className = 'jc-pdp-bar__name';
    name.setAttribute('aria-hidden', 'true');
    name.textContent = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    var price = document.createElement('div');
    price.className = 'jc-pdp-bar__price';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jc-pdp-bar__btn';
    el.appendChild(name);
    el.appendChild(price);
    el.appendChild(btn);
    document.body.appendChild(el);

    var shown = null, lastPrice = null, pending = 0, uq = false, sq = false;

    function reveal() {                            // Horizon's add error sits next to the real button: bring it into view
      var row = box(q(sec, '.buy-buttons-block')), b = realBtn();
      if (!row) return;
      // vertical only, on the real page scroller (.page-wrapper at desktop widths, else the window): scrollIntoView
      // would also scroll any overflow-x:hidden ancestor sideways
      var pw = document.querySelector('.page-wrapper');
      var target = pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible' ? pw : window;
      target.scrollBy({ top: Math.round(row.top + row.height / 2 - window.innerHeight / 2), left: 0, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      if (b && el.contains(document.activeElement)) b.focus({ preventScroll: true });
    }

    function sync() {
      if (!el.isConnected) return;
      var pc = q(sec, '.custom-price-block [ref="priceContainer"]') || q(sec, '[ref="priceContainer"]');
      var html = pc ? pc.innerHTML : '';
      if (html !== lastPrice) {
        lastPrice = html;
        price.textContent = '';
        if (pc) each(pc.childNodes, function (n) { price.appendChild(n.cloneNode(true)); });
      }
      var b = realBtn();
      var text = b ? labelOf(b) : '';
      if (btn.textContent !== text) btn.textContent = text;
      var dis = !b || b.disabled;
      if (btn.disabled !== dis) btn.disabled = dis;
      if (pending) {
        var err = q(sec, '.buy-buttons-block .product-form-text__error');
        if (Date.now() - pending > 8000) pending = 0;
        else if (err && !err.classList.contains('hidden')) { pending = 0; reveal(); }
      }
      schedule();
    }

    btn.addEventListener('click', function () {
      var b = realBtn();
      if (!b || b.disabled) return;
      var had = b.hasAttribute('data-puppet'), prev = b.getAttribute('data-puppet');
      b.setAttribute('data-puppet', 'true');       // Horizon: no fly-to-cart / tick animation from the off-screen button
      pending = Date.now();
      try { b.click(); }                           // runs Horizon's click + submit handlers synchronously: the real form posts
      finally { if (had) b.setAttribute('data-puppet', prev); else b.removeAttribute('data-puppet'); }
    });

    function onScreen(e, top, vh) { var r = box(e); return !!r && r.bottom > top && r.top < vh; }
    function set(show) {
      if (show === shown) return;
      shown = show;
      if (!show && el.contains(document.activeElement)) {   // never lose keyboard focus when the bar goes away
        var cap = null;
        each(document.querySelectorAll('.cap__add-to-cart'), function (c) { if (!cap && box(c)) cap = c; });
        var target = realBtn() || cap;
        if (target) target.focus({ preventScroll: true });
      }
      el.hidden = !show;
      barClass();
    }
    function update() {
      uq = false;
      if (!el.isConnected || !sec.isConnected) return;
      var header = document.getElementById('header-component') || document.querySelector('header-component');
      var hb = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      var vh = window.innerHeight;
      var phone = PHONE.matches;
      var r = box(q(sec, '.buy-buttons-block'));
      var show = false;
      if (r) show = phone ? !(r.bottom > hb && r.top < vh) : r.bottom <= hb;
      // JC-EVO 09/30/2026 N06 (core fork, speed): same answer, measured only when the bar's height can change it. The rules that hide
      // the bar without its height (closing band button or footer on screen, photo lightbox open) are checked first; and with the tab
      // bar's top less than 2 px below the header the bar can never fit (any height >= 0 hides it). Only otherwise is the hidden bar
      // unhidden and measured, by the same code as before (every barClass() call kept). Before, it was unhidden and measured on every
      // scroll frame while the tab bar was on screen: two forced style + layout passes per frame. The bar is position:fixed and
      // html[data-jc-pdp-bar] rules apply below 750 px only, so reading the other rects first returns the same values.
      var blocked = false;
      if (show) each(document.querySelectorAll('.cap__add-to-cart'), function (c) { if (onScreen(c, hb, vh)) blocked = true; });
      if (show && !blocked) {
        var foot = box(document.querySelector('.page-wrapper > .page-footer'));
        if (foot && foot.top < vh) blocked = true;
      }
      if (show && !blocked && document.querySelector('.cpm-lightbox.is-open')) blocked = true;   // the photo lightbox is up
      if (show && !phone && !blocked) {
        var nav = document.querySelector('.product-tabs-wrapper [data-product-tabs-nav]');
        var tabs = box(nav);
        if (tabs && tabs.bottom > hb && tabs.top < vh && tabs.right > 0 && tabs.left < window.innerWidth &&
            getComputedStyle(nav).visibility !== 'hidden') {
          if (tabs.top < hb + 2) show = false;
          else {
          // Measure this bar even while hidden: using zero height would make it reappear over the menu.
          var wasHidden = el.hidden;
          // JC-EVO 10/10/2026 (tablet live bar, Sol review): the bar sits below the header AND the open live bar
          // (top = --jc-pdp-bar-top + --b), so compare the tabs with its measured bottom, not header + height.
          if (el.style.getPropertyValue('--jc-pdp-bar-top') !== hb + 'px') el.style.setProperty('--jc-pdp-bar-top', hb + 'px');
          el.hidden = false;
          barClass();
          var barBottom = el.getBoundingClientRect().bottom;
          el.hidden = wasHidden;
          barClass();
          if (tabs.top < Math.min(vh, barBottom + 2)) show = false;
          }
        }
      }
      if (blocked) show = false;
      if (!phone) {
        var top = hb + 'px';
        if (el.style.getPropertyValue('--jc-pdp-bar-top') !== top) el.style.setProperty('--jc-pdp-bar-top', top);
        var pw = document.querySelector('.page-wrapper');
        var sbw = (pw && pw.scrollHeight > pw.clientHeight + 1 ? Math.max(0, pw.offsetWidth - pw.clientWidth) : 0) + 'px';
        if (el.style.getPropertyValue('--jc-pdp-sbw') !== sbw) el.style.setProperty('--jc-pdp-sbw', sbw);
      }
      set(show);
    }
    function schedule() { if (!uq) { uq = true; requestAnimationFrame(update); } }

    var observers = [];
    function watch(target, opts, fn) { var mo = new MutationObserver(fn); mo.observe(target, opts); observers.push(mo); }
    watch(col, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] },
      function () { if (!sq) { sq = true; requestAnimationFrame(function () { sq = false; sync(); }); } });
    each(document.querySelectorAll('.cpm-lightbox'), function (lb) { watch(lb, { attributes: true, attributeFilter: ['class'] }, schedule); });
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    onMedia(PHONE, schedule);
    // JC-EVO 10/01/2026: phones lift the chat / Klaviyo / Rebuy bubbles by the bar's real height + 12 px (jc-pdp-buy.css,
    // --jc-pdp-bar-h); a two-line button ("Pre-order ships early November") made the bar taller than the fixed 69 px before
    if (window.ResizeObserver) {
      var hro = new ResizeObserver(function () {
        var h = Math.ceil(el.getBoundingClientRect().height);
        if (h > 0 && h + 'px' !== document.documentElement.style.getPropertyValue('--jc-pdp-bar-h')) document.documentElement.style.setProperty('--jc-pdp-bar-h', h + 'px');
      });
      hro.observe(el, { box: 'border-box' });
      observers.push(hro);
    }
    TEAR[sec.id] = function () {
      observers.forEach(function (o) { o.disconnect(); });
      document.removeEventListener('scroll', schedule, true);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', schedule);
      onMedia(PHONE, schedule, true);
      el.remove();
      barClass();
      delete TEAR[sec.id];
    };
    sync();
  }

  function run() {
    each(document.querySelectorAll(SEL), function (sec) {
      [nowrapHyphens, gallery, media, labelLines, bar].forEach(function (f) {
        try { f(sec); } catch (e) { if (window.console) console.warn('[jc-pdp-buy]', e); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', function (e) { var id = e.target && e.target.id; if (id && TEAR[id]) TEAR[id](); if (id && LABELTEAR[id]) LABELTEAR[id](); });
})();
